import { IUserSubscriptionModel } from "@nf/common";

import { SettingsSubscriptionContainer } from "../SettingsSubscriptionContainer";

interface ISubscriptionListProps {
  title: string;
  subscriptions: IUserSubscriptionModel[];
  hasActiveSub: boolean;
  onCancel?: (subscription: IUserSubscriptionModel) => void;
  onCancelPause?: () => void;
}

export const SubscriptionList = ({
  title,
  subscriptions,
  hasActiveSub,
  onCancel,
  onCancelPause,
}: ISubscriptionListProps) => (
  <>
    <h2>{title}</h2>
    {subscriptions.map((subscription) => (
      <SettingsSubscriptionContainer
        key={subscription.Id}
        subscription={subscription}
        hasActiveSub={hasActiveSub}
        onCancel={onCancel}
        onCancelPause={onCancelPause}
      />
    ))}
  </>
);
